import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { BrokerageAppointmentSearchResponse } from '@lio/api-types';
import { useClient } from '@utils/api-client';

export const useGetBrokerageAppointments = ({ brokerageId }: { brokerageId: string | null }) => {
  const client = useClient();
  const result = useQuery({
    enabled: !!brokerageId,
    placeholderData: keepPreviousData,
    queryKey: ['brokerageAppointment', { brokerageId }],
    queryFn: () =>
      client.get(`brokerage/${brokerageId}/brokerage-appointment`).json<BrokerageAppointmentSearchResponse>(),
    refetchOnWindowFocus: false,
  });

  return { ...result, brokerageAppointments: result.data?.items };
};
